/**
 * Created by zml on 4/22/2016.
 */
(function () {
  'use strict';

  angular
    .module('betosyswebapp')
    .controller('FrameworkController', FrameworkController);

  // FrameworkController.$inject = ['$scope', '$timeout', '$window', 'PubSubService', 'AuthenticationService', 'Restangular'];

  /* @ngInject */
  function FrameworkController($scope, $timeout, $window, PubSubService, $translate, customerService) {
    var vm = this;

    //var campaignMenuItem = createCampaignMenuItem();

    vm.headerModel = createHeaderModel();
    vm.languageModel = createLanguageModel();
    // vm.sidebarModel = createSideBarModel();

    init();

    ////////////////

    function init() {
      //onStateChanged();
      onSideBarToggle();
      //onCampaignStatusChanged();
    }

    function createLanguageModel() {
      var model = {
        languages: ['en', 'de', 'nl']
      };
      return model;
    }

    function createHeaderModel() {
      var model = {
        logo: '<b>' + customerService.getProductLogText() + '</b>',
        miniLogo: '<b>' + customerService.getProductLogoShortText() + '</b>',
        href: 'home'
      };
      return model;
    }

    /**
     * This method will register one listener on toggling side bar to trigger WINDOW RESIZE EVENT for jqxWidget to
     * do relayout.
     */
    function onSideBarToggle() {

      PubSubService.subscribe('_TOGGLE_SIDEBAR_', function () {

        $timeout(function () {
          $window.dispatchEvent(new Event('resize'));
        }, 500);

      }, $scope);
    }
  }

})();




// WEBPACK FOOTER //
// ./.tmp/components/framework/framework.controller.js